import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useApiRequest } from "../Login/Hooks/useApiRequest";
import NearbyVmList from "./NearbyVmList";
import RecentVmList from "./RecentVmList";
import NoVmFound from "./NoVmFound";
import { Box } from "@mui/material";
import Banner_Container from "../../Banners/container";
import SearchBar from "./SearchVm";
import LocationPage from "./LocationPage";
import Game from "../Game/component";
import TopNavbar from "./header";
import QrModal from "./Qr";
import BottomNarBar from "../../BottomNav/Bottom";
import Procced from "../../ProccedToPay/component";
import PendingPickup from "../PendingPickup/component";

const VmlistContainer = () => {
  const { makeApiRequest } = useApiRequest();
  const navigate = useNavigate();

  const [nearbyVmlist, setNearbyVmlist] = useState([]);
  const [recentVmlist, setRecentVmlist] = useState([]);
    const [totalAmount, setTotalAmount] = useState(0);
    const [activeOrders,setActiveOrders]=useState([])
  const [userDetails, setUserDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [qrModelflag, setQrModelflag] = useState(false);
    const [preCart, setPreCart] = useState([]);
    const [showLoction,setshowLoction]=useState(true)

  // Redirect if user is not logged in
  useEffect(() => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    if (!UserJWTAuth) navigate("/login");
  }, [navigate]);

  // Fetch VM list if location exists
  useEffect(() => {
    const lat = localStorage.getItem("lat");
    const lng = localStorage.getItem("lng");
    if (lat && lng && navigator.onLine) {
      fetchVmList(lat, lng);
    }
  }, []);

  const getLocation = () => {
    if (!navigator.geolocation) {
      toast.error("Geolocation is not supported by this browser.", { autoClose: 2000 });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const { latitude, longitude } = coords;
        localStorage.setItem("lat", latitude);
        localStorage.setItem("lng", longitude);
        fetchVmList(latitude, longitude);
      },
      (error) => {
        const messages = {
          1: "User denied the request for Geolocation",
          2: "Location information is unavailable",
          3: "The request to get user location timed out",
        };
        toast.error(messages[error.code] || "An unknown error occurred", { autoClose: 2000 });
      }
    );
  };

  const fetchVmList = (lat, lng) => {
    setshowLoction(false)
    setLoading(true);
    const token = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");

    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/outlet/search?nearbyLimit=50&recentLimit=6&lat=${lat}&lng=${lng}`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
      },
      handleSuccess: (res) => {
        
        setNearbyVmlist(res?.data.data.nearbyMachines || []);
        setRecentVmlist(res?.data.data.recentMachines || []);
        setLoading(false);
      },
      handleError: (err) => {
        //console.error("VM List Error:", err);
        toast.error("Failed to load vending machines.", { autoClose: 1500 });
        setLoading(false);
      },
    });
  };

  const fetchUserDetails = () => {
    const token = localStorage.getItem("UserJWTAuth");
    if (!token) return;

    const deviceId = localStorage.getItem("uuid");
    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/user/loyalty/details`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId || "",
      },
      handleSuccess: (res) => setUserDetails(res.data.data),
      handleError: () => {},
    });
  };


    const fetchPreCart = () => {
      const token = localStorage.getItem("UserJWTAuth");
      if (!token) return;
  
      makeApiRequest({
        url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/cart`,
        method: "GET",
        headers: { Authorization: `Bearer ${token}` },
        handleSuccess: handleResponsePreCart,
        handleError: handleErrorPreCart,
      });
    };
  
  
    const fetchActiveOrders = () => {
    const UserJWTAuth = localStorage.getItem("UserJWTAuth");
    const deviceId = localStorage.getItem("uuid");
  
    makeApiRequest({
      url: `https://api-prod.daalchini.co.in/consumerbe/api/v2/order/active`,
      method: "GET",
      headers: {
        Authorization: `Bearer ${UserJWTAuth}`,
        "x-app-platform": "web",
        "x-app-version": "v1.0.1",
        "x-device-id": deviceId,
        accept: "application/json, text/plain, */*",
      },
      handleSuccess: (res) => {
        //console.log("Active Orders Response:", res?.data?.data);
        // Do something with active orders, e.g.,
        setActiveOrders(res?.data?.data || []);
      },
      handleError: (err) => {
       // console.error("Failed to fetch active orders:", err);
      /*   toast.error("Unable to fetch active orders.", {
          position: "top-right",
          autoClose: 1500,
        }); */
      },
    });
  };
  
    const handleResponsePreCart = (res) => {
      const cartItems = res?.data?.data?.items || [];
      const preMachineId = res?.headers?.["machineid"];
   const totalAmount = cartItems.reduce((sum, item) => sum + (item.amount * item.count), 0);
  
  //console.log("Total Amount:", totalAmount);
        setTotalAmount(totalAmount);
  
      setPreCart(cartItems);
     

    };
  
    const handleErrorPreCart = (error) => {
      //console.error("❌ Pre-cart fetch error:", error);
      if (error.response?.status === 401 || error.response?.status === 403) {
        localStorage.removeItem("UserJWTAuth");
      
      } else {
        toast.error(`${error.response?.data?.status?.code || "Error"}`, {
          position: "top-right",
          autoClose: 1000,
        });
      }
    };

  useEffect(() => {
    fetchUserDetails();
    fetchPreCart()
    fetchActiveOrders()

  }, []);

  const ShowQRFun = (e) =>{
    
    setQrModelflag(true)



  }

    const CloseQrFun = (e) =>{
    
    setQrModelflag(false)



  }

  const lat = localStorage.getItem("lat");
  const lng = localStorage.getItem("lng");

  if (showLoction) return <LocationPage fetchVmList={fetchVmList}   setshowLoction={ setshowLoction}  />;

  return (
    <>
      {qrModelflag ? (
        <QrModal ShowQRFun={ShowQRFun} qrModelflag={qrModelflag}  CloseQrFun={CloseQrFun}  />
      ) : (
        <>
        
          <TopNavbar
            LoctionPinHeader={true}
            QrMarkHeader={true}
            shareLocation={getLocation}
            ShowQRFun={ShowQRFun}
           preCart={preCart}
          />
          <Box
            sx={{
              padding: 2,
              position: "relative",
              minHeight: "100vh",
              background: "radial-gradient(circle, rgba(245,233,233,0.4) 0%, rgba(185,245,247,0.34) 100%)",
              overflow: "hidden",
              "&::before": {
                content: '""',
                position: "absolute",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0,0,0,0.1)",
                zIndex: 0,
                animation: "fadeOverlay 5s ease-in-out infinite alternate",
              },
              "@keyframes fadeOverlay": {
                from: { opacity: 0.2 },
                to: { opacity: 0.4 },
              },
            }}
          >
            <Box sx={{ position: "relative", zIndex: 1 }}>
             
             {userDetails&& <Game data={userDetails} />}
              <Banner_Container vmid={0} />
              <SearchBar />
             <div
  style={{
    paddingBottom:
      activeOrders && activeOrders[0] && preCart && preCart[0]
        ? "135px"
        : preCart && preCart[0]
        ? "50px"
        : activeOrders && activeOrders[0] && activeOrders.length > 1
        ? "115px"
        : activeOrders && activeOrders[0]
        ? "80px"
        : "0px", // fallback padding if none are true
  }}
>
                {recentVmlist.length > 0 && (
                <RecentVmList recentVmlist={recentVmlist} loading={loading} onFetchLocation={getLocation} />
              )}

              {nearbyVmlist.length > 0 && (
                <NearbyVmList nearbyVmlist={nearbyVmlist} loading={loading} onFetchLocation={getLocation} />
              )}
              </div>
            
              {nearbyVmlist.length === 0 && recentVmlist.length === 0 && <NoVmFound />}
            </Box>
          </Box>
                {preCart&&preCart[0]&&<Procced preCart={preCart}  totalAmount={totalAmount}  bottom={"90px"} page={"vmlist"}/>}
                 {activeOrders&&activeOrders[0]&&<PendingPickup activeOrders={activeOrders} preCart={preCart}  page={"vmlist"}/>}

          <BottomNarBar/>
        </>
      )}
    </>
  );
};

export default VmlistContainer;
